import { html } from "lit";
export const render = {
    blockMath: element => html `<ch-math-viewer
      display-mode="block"
      .value=${
    // The final replace is a WA because the parser doesn't remove the final backslash
    element.value}
    ></ch-math-viewer>`,
    inlineMath: element => html `<ch-math-viewer
      display-mode="inline"
      .value=${
    // The final replace is a WA because the parser doesn't remove the final backslash
    element.value}
    ></ch-math-viewer>`
};
